import { useEffect } from 'react'
import useEP from './useEP'
import { getPersonDetails } from '../services/services'

export default function usePersonDetails(personId) {
  const [state, dispatch, fn] = useEP(getPersonDetails)
  useEffect(() => {
    if (personId) {
      dispatch({ type: 'load' })
    }
  }, [dispatch, personId])

  useEffect(() => {
    if (state.load) {
      getPersonDetails({ personId }).then((res) => {
        dispatch({ type: 'complete', res })
      })
    }
  }, [dispatch, personId, state.load])

  return [state, fn, dispatch]
}
